import "react-toastify/dist/ReactToastify.css";

import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { Id } from "react-toastify";

import { renewSubscription } from "~/api/stripe/renew";
import MainButton from "~/components/common/mainButton";
import Modal from "~/components/ui/modal";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";

import styles from "./index.module.scss";

type Props = {
  renew: boolean;
  successNotification: () => Id;
};

const SubscriptionRenewal = ({ renew, successNotification }: Props) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [error, setError] = useState("");

  const { language } = useLanguage();
  const accountTexts =
    language === "En"
      ? englishTranslations.accountPage
      : frenchTranslations.accountPage;

  const queryClient = useQueryClient();

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const { mutate, isLoading } = useMutation(renewSubscription, {
    onSuccess: () => {
      successNotification();
      queryClient.invalidateQueries("user");
      handleCloseModal();
      console.log("success");
    },
    onError: () => {
      setError("Une erreur est survenue, veuillez réessayer.");
    },
  });

  const handleUpdateRenewal = () => {
    // it is the opposite of the current value
    mutate(!renew);
  };

  const buttonText = renew
    ? accountTexts.cancelSubscription
    : accountTexts.reactivateMySubscription;
  const modalText = renew
    ? "Êtes-vous sûr de vouloir annuler votre abonnement ?"
    : "Souhaitez-vous réactiver votre abonnement ?";

  return (
    <div className={styles.container}>
      <MainButton onClick={() => setModalOpen(true)}>{buttonText}</MainButton>
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <div className={styles.modalContainer}>
          <p>{modalText}</p>
          <div className={styles.buttonsContainer}>
            {!isLoading && (
              <MainButton onClick={handleCloseModal}>Non</MainButton>
            )}
            <MainButton onClick={handleUpdateRenewal} isLoading={isLoading}>
              Oui
            </MainButton>
          </div>
          {error && <p className={styles.error}>{error}</p>}
        </div>
      </Modal>
    </div>
  );
};

export default SubscriptionRenewal;
